import { useGetEconomicActivities } from '@entities/economic-activity';
import { TableFilters } from '@shared/ui';
import { useMemo } from 'react';
import { companyFiltersConfig, initialValues } from './constants';
import { type CompanyFiltersQuery } from './types';

type CompanyListFiltersProps = {
  pageSize?: number;
  setFilter: (filter: CompanyFiltersQuery) => void;
};

export const CompanyListFilters = ({
  setFilter,
  pageSize,
}: CompanyListFiltersProps) => {
  const { data, isLoading } = useGetEconomicActivities();
  const config = useMemo(
    () =>
      companyFiltersConfig.map(field => {
        if (field.name !== 'economicActivitiesName') {
          return field;
        }

        return {
          ...field,
          disabled: isLoading,
          loading: isLoading,
          options:
            data?.data.map(activity => ({
              label: activity.name,
              value: activity.name,
            })) ?? [],
        };
      }),
    [data, isLoading]
  );

  return (
    <TableFilters
      config={config}
      initialValues={initialValues}
      setFilter={setFilter}
      pageSize={pageSize}
    />
  );
};
